import axios from '@/axios';

const signIn = payload => axios.post('/auth', payload);
const profile = () => axios.get('/auth');
const askToken = email => axios.post('/v2/cadastro/solicitar-token', { email });
const passwordRecovery = payload => axios.post('/v2/cadastro/passwordRecovery', payload);

export { signIn, profile, askToken, passwordRecovery };
